import { BufferGeometry, Float32BufferAttribute, Vector2, Vector3 } from "three";

/**
 * Erzeugt einen Circle, deren UV-Koordinaten mit der Größe skaliert sind
 */
export class CircleUvBufferGeometry extends BufferGeometry {
  parameters: {
    radius: number;
    segments: number;
    thetaStart: number;
    thetaLength: number;
  };

  constructor(radius?: number, segments?: number, thetaStart?: number, thetaLength?: number) {
    super();

    this.parameters = {
      radius: radius !== undefined ? radius : 1,
      segments: segments !== undefined ? segments : 8,
      thetaStart: thetaStart !== undefined ? thetaStart : 0,
      thetaLength: thetaLength !== undefined ? thetaLength : Math.PI * 2,
    };

    radius = radius || 1;
    segments = segments !== undefined ? Math.max(3, segments) : 8;

    thetaStart = thetaStart !== undefined ? thetaStart : 0;
    thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;

    // buffers

    const indices: number[] = [];
    const vertices: number[] = [];
    const normals: number[] = [];
    const uvs: number[] = [];

    // helper variables

    let i, s;
    const vertex = new Vector3();
    const uv = new Vector2();

    // center point

    vertices.push(0, 0, 0);
    normals.push(0, 0, 1);
    uvs.push(0.5, 0.5);

    for (s = 0, i = 3; s <= segments; s++, i += 3) {
      const segment = thetaStart + (s / segments) * thetaLength;

      // vertex

      vertex.x = radius * Math.cos(segment);
      vertex.y = radius * Math.sin(segment);

      vertices.push(vertex.x, vertex.y, vertex.z);

      // normal

      normals.push(0, 0, 1);

      // uvs

      uv.x = vertices[i] / 2;
      uv.y = vertices[i + 1] / 2;

      uvs.push(uv.x, uv.y);
    }

    // indices

    for (i = 1; i <= segments; i++) {
      indices.push(i, i + 1, 0);
    }

    // build geometry

    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
}
